module.exports = __webpack_public_path__ + "img/Frame 1109two1.c882aa91.png";